export default __webpack_public_path__ + "static/banner_connpass-c133f469c66f5b3baafc7ae59051198a.png";